module.exports = __webpack_public_path__ + "static/bannerMyPackage-f7856c4e1703fbb2900b40029e0b4999.jpg";